import { IEffectivePercentAttainment } from '../../interfaces/ieffective-percent-attainment';
import { AssetTeam } from '../asset-team';
import { Scenario } from '../scenario';

export class EffectivePercentAttainmentBase {
  EffectivePercentAttainmentId: number;
  EffectiveDate: Date;
  PercentAttainment: number;
  AssetTeamId: number;
  ScenarioId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  Scenario?: Scenario;

  constructor(item?: IEffectivePercentAttainment) {
    if (item) {

      this.EffectivePercentAttainmentId = item.EffectivePercentAttainmentId;
      this.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : null;
      this.PercentAttainment = item.PercentAttainment;
      this.AssetTeamId = item.AssetTeamId;
      this.ScenarioId = item.ScenarioId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}